<template>
  <FormElement>
    <template slot="label">
      <span>{{ label }}</span>
    </template>

    <template slot="warning">
      <span class="-require" v-if="required">*ต้องเลือกข้อมูล</span>
    </template>

    <div class="select-box">
      <div class="-input">
        <select
          :disabled="options.length < 1"
          v-model="selection"
          @change="handleChange({ options, selection })"
        >
          <template v-for="(option, index) in options">
            <option
              class="--option"
              :key="index"
              :value="option.id"
              :disabled="option.disable"
            >
              {{ option.title }}
            </option>
          </template>
        </select>
      </div>
    </div>
  </FormElement>
</template>

<script>
  import FormElement from '../form-element';

  export default {
    components: {
      FormElement
    },
    props: {
      label: String,
      prop: [String, Array, Object],
      options: {
        type: Array,
        default: () => []
      },
    required: {
      type: Boolean,
      default: false,
    },
    edata: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      selection: "",
      key: "",
    }
  },
  watch: {
    selection: function (key) {
      if (this.prop && key) {
        if (Array.isArray(this.prop)) {
          const selectedOption = this.options.find(option => option.id === key);
          const multipleValues = this.extractValue(selectedOption);
          this.$emit("input", { multipleValues })
      //     let _val = {};
      //     for (const prop of this.prop) {
      //       if (typeof prop === 'object' && prop !== null) {
      //         _val[prop.transform] = val[prop.transform];
      //       } else {
      //         _val[prop] = val[prop];
      //       }
      //     }
      //     // console.log(_val);
      //     this.$emit("input", _val);
        } else if (typeof this.prop === 'object' && this.prop !== null) {
          this.$emit("input", { prop: this.prop.transform, data: key })
        } else {
          this.$emit("input", { prop: this.prop, data: key });
        }
      }
    }
  },
  methods: {
    handleChange({ options, selection }) {
      this.$emit('change', { options, selection } );
    },
    extractValue(option) {
      if (Array.isArray(this.prop)) {
        let val = {};
        for (const prop of this.prop) {
          if (typeof prop === 'object' && prop !== null) {
            val[prop.transform] = option[prop.target];
          } else {
            val[prop] = option[prop];
          }
        }
        return val;
      }
      else if (typeof this.prop === 'object' && this.prop !== null) {
        return option[this.prop.target];
      } else {
        return option[this.prop];
      }
    }
  },
  mounted() {
    if (this.edata !== null) {
      this.$set(this, 'selection', this.edata);
      this.$forceUpdate();
    }
  },
  beforeUpdate() {
    if (this.edata !== null) {
      this.$set(this, 'selection', this.edata);
    }
  }
}
</script>

<style lang="scss" scoped>
.-input {
  width: 100%;
  padding: 0.5rem;
  padding-right: 0;

  & select {
    width: 100%;
    margin: 0;
    height: 100%;
    border: none;
    font-size: 1.2rem;
  }
}

</style>
